/* unplugin-vue-components disabled */import script from "./ProductBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductBox.vue?vue&type=script&setup=true&lang=js"

import "./ProductBox.vue?vue&type=style&index=0&id=63c1f50c&lang=scss"

export default script